module.exports = __webpack_public_path__ + "img/ignore.460577ca.svg";